/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBcPoNumberWithCommentboxViewProps } from './bc-po-number';

export default (props: IBcPoNumberWithCommentboxViewProps) => {
    return (
        <div>
            {props.input}
            {props.poNumber}
        </div>
    );
};
